// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qOEm","toggle":"styles_toggle__P2trS","preview":"styles_preview__2HbNq"};